import Model from './referal_reports.model'

let storeContent = utils.generateStore({
   Model,
   referal_reports: [],
   promotion__redemptions: [],
   coupons: [],
   selected_referal_reports: [],
   customer: null
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async filterCoupons(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await ctx.dispatch('filterReferals',data)
               await ctx.dispatch('filterRuleBaseCoupons',data)
               await ctx.dispatch('filterPromotionalCoupons',data)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async filterReferals(ctx, data) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        referee_email: ctx.getters.customer.email,
                        created_at: {
                           $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                           $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                        }
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "referal_reports",
               }
            })
            ctx.commit('referal_reports', res.result.records);
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async filterRuleBaseCoupons(ctx, data) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        customer_id: ctx.getters.customer.email,
                        created_at: {
                           $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                           $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                        }
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "coupon",
               }
            })
            ctx.commit('coupons', res.result.records);
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async filterPromotionalCoupons(ctx, data) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        customer_id: ctx.getters.customer.email,
                        created_at: {
                           $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                           $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                        }
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "promotion_coupon_redemption",
               }
            })
            ctx.commit('promotion__redemptions', res.result.records);
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchCustomer(ctx, payload) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        _id: payload.id
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "customer",
               }
            })

            ctx.commit('customer', res.result.records[0]);
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async viewCustomer(ctx, payload) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        email: payload.email
                     }
                  }
               },
               meta_data: {
                  service: "rewards",
                  collection: "customer",
               }
            })

            ctx.getters.router.push({name: 'Customer-View', params: {id: res.result.records[0]._id}})
            ctx.getters.router.go()
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async handleActions(ctx, payload) {
         if (payload.action === 'view:customer') {
            await ctx.dispatch('viewCustomer',{email: payload.rows[0].customer_email})
         }
      },
      async fetchData(ctx,payload) {
         try {
            await ctx.dispatch('fetchCustomer',payload)
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};